import React from "react";
import SubTitle from "../../components/SubTitle";
//import ArticleItem from "../../components/articles/ArticleItem";
import ClassSubTitle from "../../components/classes/ClassSubTitle";

const IndexSection = ({ title, titleJP, items, bottomText, bottomTextJP }) => {
  return (
    <div className="classes-view-section">
      <div className="container classes-view-main index-section">
            <div className="classes-view-title">
              {/* Section Header */}
              <SubTitle title={title} subTitle={titleJP} />
              
              <div className="right-section flex">
                  {items.map((item, key) => {
                  return (
                      <ClassSubTitle
                        key={key}
                        href={item.link}
                        title={item.title}
                        subTitle={item.titleJP}
                        textColor={item.textColor}
                        index={key + 1}
                      />
                  );
                  })}
              </div>
              {/* Optional section-level bottom text */}
              {(bottomText || bottomTextJP) && (
                  <div className="section-bottom-text">
                  {bottomText} / {bottomTextJP}
                  </div>
              )}
            </div>
      </div>
    </div>  
  );
};

export default IndexSection;